import type { ApiOrgId } from 'api/types/ApiTypedId';
import { postJson } from 'utils/http/postJson';

import type {
  OrgDashboardApiCartInvoice,
  OrgDashboardApiNewCartItem,
} from './types/OrgDashboardApiInvoice';

export function addItemsToCart(
  orgId: ApiOrgId,
  items: OrgDashboardApiNewCartItem[],
): Promise<{
  invoices: OrgDashboardApiCartInvoice[];
  itemsInCart: number;
}> {
  return postJson<{
    invoices: OrgDashboardApiCartInvoice[];
    itemsInCart: number;
  }>(`/data/orgdashboard/${orgId}/cart`, { items });
}
